(() => {
  const normalizedPath =
    window.location.pathname.replace(/\/+$/, '') || '/';

  const isHomePage =
    normalizedPath === '/' ||
    normalizedPath === '/ru' ||
    normalizedPath === '/uk' ||
    document.querySelector('main[data-template="index"]') ||
    document.body.classList.contains('template-index');

  if (!isHomePage) return;
  if (window.location.hash) return;

  const navigationEntry =
    performance.getEntriesByType('navigation')[0];

  if (navigationEntry?.type === 'back_forward') return;

  const previousScrollRestoration =
    'scrollRestoration' in history
      ? history.scrollRestoration
      : null;

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'auto'
  });

  requestAnimationFrame(() => {
    /*
      Повторно ставимо нагору лише тоді, коли користувач
      ще не почав прокручувати сторінку.
    */
    if (window.scrollY <= 1) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });
    }

    if (
      previousScrollRestoration !== null &&
      'scrollRestoration' in history
    ) {
      history.scrollRestoration = previousScrollRestoration;
    }
  });
})();